import { useQuery as useShowSaleHubNudge } from "@faire/web-api--source/api/retailer/show-deals-hub-nudge/get-hooks";
import { SALE_ANNOUNCEMENT_DISMISSED } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SALE_ANNOUNCEMENT_DISMISSED";
import { useIsLoggedInRetailer } from "@faire/retailer/lib/isLoggedInRetailer";
import { useSettingDealsHub } from "@faire/retailer/settings/useSettingDealsHub";
import { useSettingSalesHubPowerUsers } from "@faire/retailer/settings/useSettingSalesHubPowerUsers";
import { useMilestone } from "@faire/retailer/stores/domain/useMilestone";
export var useShouldShowSaleAnnouncementNudge = function() {
    var _useMilestone = useMilestone(SALE_ANNOUNCEMENT_DISMISSED), hasDismissedSaleAnnouncement = _useMilestone.hasOccurred;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var isSaleHubUpdate = useSettingDealsHub();
    var isPowerUserSalesHubUpdate = useSettingSalesHubPowerUsers();
    var _useShowSaleHubNudge = useShowSaleHubNudge({
        enabled: isLoggedInRetailer
    }), data = _useShowSaleHubNudge.data, isLoading = _useShowSaleHubNudge.isLoading;
    var shouldShowSalesHubNudge = (data === null || data === void 0 ? void 0 : data.should_show_nudge) && isSaleHubUpdate;
    var shouldShowPowerUserSalesNudge = (data === null || data === void 0 ? void 0 : data.should_show_flash_sales_power_user_nudge) && isPowerUserSalesHubUpdate;
    return !hasDismissedSaleAnnouncement && !isLoading && (shouldShowSalesHubNudge || shouldShowPowerUserSalesNudge);
};
